import AddUserPage from './AddUserPage';
import AuthRoles from '@/app/auth/authRoles';

const AddUserConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.UserManagement,
  routes: [
    {
      path: 'users/add',
      element: <AddUserPage />,
    },
  ],
};

export default AddUserConfig;
